import { apiFetch } from './apiClient';

export interface ChatMessage {
  role: "user" | "assistant" | "system";
  content: string;
}

export interface AIResponse {
  text: string;
  error?: string;
}

export async function callAI(provider: string, model: string, prompt: string, messages?: ChatMessage[], apiKey?: string): Promise<AIResponse> {
  try {
    const response = await apiFetch("/api/ai/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiKey || "",
      },
      body: JSON.stringify({ provider, model, prompt, messages }),
    });

    if (!response.ok) {
      let errorMsg: string;
      try {
        const errorData = await response.json();
        errorMsg = errorData.error || `AI server returned ${response.status}`;
      } catch {
        errorMsg = `AI server returned ${response.status}`;
      }
      throw new Error(errorMsg);
    }

    return await response.json();
  } catch (error: any) {
    console.error("AI Service Error:", error);
    return { text: "", error: error.message || "Connection failed — backend may be starting" };
  }
}
